module.exports = __webpack_public_path__ + "media/images/pages/contributor_overview/icon_ownership-ade9fcb47ddb177d38089cbac44c900e.png";